import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

const SkillPopup = ({
    showSkillDescription,
    setShowSkillDescription
}) => {
    const location = useLocation();
    const crumbs = [
        { label: "Home", url: "/" },
        { label: "My Skill Journey", url: location }
    ];
    const navigate = useNavigate();
    const skillName = showSkillDescription.skillName ?? showSkillDescription.Skills ?? "";
    const skillGroupName = showSkillDescription.skillGroup ?? showSkillDescription.SkillGroup ?? "";
    const skillDescription = showSkillDescription.SkillDescription ?? "";
    const roleName = showSkillDescription.RoleName ?? showSkillDescription.Role ?? "";


    const navigateTo = (skillName, SkillGroupName, SkillDescription, RoleName, hist) => {
        let skillNameandDescription = [skillName, SkillDescription, SkillGroupName, RoleName, hist];
        sessionStorage.setItem("settingSkillNameandDescription", JSON.stringify(skillNameandDescription));
        navigate("/roleskilljourney/viewcontent", { state: { crumbs, viewContent: true } });
    };

    return (
        <Modal
            centered
            show={!!showSkillDescription}
            className="skill-description-modal"
            onHide={() => setShowSkillDescription(null)}
            aria-labelledby="custom-modal-styling-title"
            size="lg"
            scrollable
        >
            <Modal.Header closeButton>
                <Modal.Title
                    id="custom-modal-styling-title"
                    className="mb-0 header-line px-3"
                >
                    {skillName}
                    <h4>{skillGroupName}</h4>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ textAlign: "justify" }}>
                <h2 className="skill-description-text-h2 px-3">Skill Description</h2>

                <div className="success-modal-container skill-description">
                    <div className="content-section skill-description-content-section px-3">
                        {skillDescription ? (
                            <div
                                className="skill-description-textarea"
                                dangerouslySetInnerHTML={{
                                    __html: skillDescription
                                }}
                            />
                        ) : (
                            <p className="skill-description-textarea">
                                No Description Available
                            </p>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-right">
                <div className="failure-modal-container-footer">
                    <button
                        className="btn primary-btn primary-blue m-2"
                        onClick={() =>
                            navigateTo(
                                skillName,
                                skillGroupName,
                                skillDescription,
                                roleName,
                                showSkillDescription
                            )
                        }
                    >
                        View Content
                    </button>
                </div>
            </Modal.Footer>

        </Modal>
    );
};

export default SkillPopup;
